import { ROLE } from '@cmoh/shared'
import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const ContentListPage = lazyWithRetry(() => import('./pages/ContentListPage'))
const ContentDetailPage = lazyWithRetry(() => import('./pages/ContentDetailPage'))

const routes: AppRoute[] = [
  {
    path: 'contents',
    element: ContentListPage,
    meta: { title: 'sidebarNav.myContents', require: { minRole: ROLE.MEMBER } },
  },
  {
    path: 'contents/:contentId',
    element: ContentDetailPage,
    meta: { title: 'contentList.detail.title', require: { minRole: ROLE.MEMBER } },
  },
]

export default routes

